package ru.it_mozaika.sender.js.application.frames.stores

import js.core.jso
import mui.material.*
import mui.system.responsive
import mui.system.sx
import react.*
import ru.it_mozaika.components.*
import ru.it_mozaika.sender.common.models.Store
import ru.it_mozaika.sender.js.application.components.stores.addNewStoreDialog
import ru.it_mozaika.components.commonTableSkeletonFrame
import ru.it_mozaika.sender.js.application.context.StoreContext
import ru.it_mozaika.sender.js.application.frames.MainCard
import tanstack.react.table.useReactTable
import tanstack.table.core.ColumnDef
import tanstack.table.core.ColumnDefTemplate
import tanstack.table.core.StringOrTemplateHeader
import tanstack.table.core.getCoreRowModel
import web.cssom.*

val StoresListFrame = VFC {
    var stores by useState(listOf<Store>())
    var rowsPerPage by useState(10)
    var page by useState(0)
    var size by useState(0)
    val tableColumns = listOf("id" to "ID", "name" to "Название", "url" to "URL")
    val (showDialog, setShowDialog) = useState(false)
    val context = useContext(StoreContext)
    val (showStoreEditDialog, setShowStoreEditDialog) = useState(false)
    useEffect(context.storeList) {
        size = context.storeList.size
        stores = context.storeList
    }
    val table = useReactTable<Store>(
        options = jso {
            this.columns = useMemo(tableColumns) {
                tableColumns.map { (column, title) ->
                    jso<ColumnDef<Store, Any?>> {
                        accessorFn = { item, _ ->
                            when (column) {
                                "id" -> item.id
                                "name" -> item.name
                                "url" -> item.url
                                else -> ""
                            }

                        }
                        cell = ColumnDefTemplate { context ->
                            val value = context.getValue().toString()
                            Box.create { +value }
                        }
                        id = column
                        header = StringOrTemplateHeader(title)
                    }
                }
            }.toTypedArray()
            this.data = useMemo(stores) { stores.toTypedArray() }
            this.state = jso {
            }
            this.onColumnVisibilityChange = {
            }
            this.onColumnOrderChange = {
            }
            this.getCoreRowModel = getCoreRowModel()
            this.debugTable = true
            this.debugHeaders = true
            this.debugColumns = true
        }
    )
    addNewStoreDialog {
        this.isOpen = showDialog
        this.onClose = {
            setShowDialog(false)
            context.updateStoreList()
        }
    }
    storeEditDialog {
        isOpen = showStoreEditDialog
        onClose = {
            setShowStoreEditDialog(false)
        }
    }

    MainCard {
        title = "Магазины"
        this.actions = Stack.create() {
            this.direction = responsive(StackDirection.row)
            this.divider = Divider.create {
                orientation = Orientation.vertical
            }
            asDynamic().spacing = 2
            sx {
                this.width = 100.pct
                border = 2.px
                this.alignItems = AlignItems.center
                this.justifyContent = JustifyContent.flexStart
            }
            AvatarButton {
                this.tooltipTitle = "Добавить магазин"
                onClick = {
                    setShowDialog(true)
                }
                mui.icons.material.AddCircleOutline()
            }
        }
        commonTableSkeletonFrame {
            this.showCheckBox = false
            this.table = table
            this.onPropertySelect = { property ->
            }
            this.columnId = "id"
            this.label = "stores"
            this.onDoubleClickHandler = {
                context.setStore(it)
                setShowStoreEditDialog(true)
            }
            this.onSelectionChanged = { _ ->
            }
        }
        tablePagination {
            this.page = page
            this.size = size
            this.handleChangePage = { newPage ->
                page = newPage
            }
            this.handleChangeRowsPerPage = { event ->
                rowsPerPage = event.target.asDynamic().value as Int
                page = 0
            }
            this.currentRowsPerPageValue = rowsPerPage
        }
    }
}